import tmplFilterItem from './mapbox-filter-item.twig';
import Utils from 'common/scripts/utils';

const HIDDEN_CLASS = 'is-hidden';
const OPEN_FILTER_CLASS = 'mapbox-filter_theme_open';
const OPEN_CLASS = 'is-opened';

export default class MapboxFilter {
    constructor(wrapperMap, iconElems) {
        this.iconElems = iconElems;
        this.wrapperMap = wrapperMap;
        this.filter = null;
        this.filterInputsIcons = null;
        this.filterCloseBtns = null;
        this.filterOpenBtns = null;
        this.filterToggleTexts = null;
        this.isShowAllIcons = true;
        this.contentWrapper = null;
        this.filterList = null;
        this.content = null;
        this.defaultHeight = 0;
    }

    init(outputData, iconsData) {
        this._initFilterElements();
        this._addFilterItems(outputData, iconsData);
        this._bindFilterElements();
        this._setHeightContentWrapper(this.defaultHeight);
    }

    _addFilterItems(outputData, iconsData) {
        outputData.forEach((icon) => {
            iconsData.forEach((iconSrcData) => {
                if (icon.type === iconSrcData.type) {
                    iconSrcData.count = iconSrcData.count + 1;
                }
            });
        });

        iconsData.forEach((iconSrcData) => {
            if (iconSrcData.count > 0) {
                this.filterList.insertAdjacentHTML('beforeend', tmplFilterItem(iconSrcData));
            }
        });
    }

    _initFilterElements() {
        const parent = this.wrapperMap.parentElement;

        this.filter = parent.querySelector('.j-mapbox-filter');
        this.filterCloseBtns = Array.from(this.filter.querySelectorAll('.j-mapbox-filter-close'));
        this.filterOpenBtns = Array.from(this.filter.querySelectorAll('.j-mapbox-filter-open'));
        this.filterToggleTexts = Array.from(this.filter.querySelectorAll('.j-mapbox-filter-toggle-text'));
        this.filterList = this.filter.querySelector('.j-mapbox-filter-list');
        this.contentWrapper = this.filter.querySelector('.mapbox-filter__footer-wrap');
        this.content = this.filter.querySelector('.mapbox-filter__footer');
    }

    _bindFilterElements() {
        this.filterInputsIcons = Array.from(this.filter.querySelectorAll('.j-mapbox-filter-input'));

        this.filterInputsIcons.forEach((input) => {
            input.addEventListener('change', (event) => {
                return this._handleChangeInput(event);
            });
        });

        this.filterToggleTexts.forEach((textElem) => {
            textElem.addEventListener('click', () => {
                this._toggleVisibleAllIcons(this.isShowAllIcons);
                this._toggleCheckedInputs(!this.isShowAllIcons);
                this._setIsShowAllIcons();
                this._toggleFilterText();
            });
        });

        this.filterCloseBtns.forEach((closeBtn) => {
            closeBtn.addEventListener('click', () => {
                this._hideContent();

                this.filterOpenBtns.forEach((openBtn) => {
                    openBtn.classList.remove(OPEN_CLASS);
                });
            });
        });

        this.filterOpenBtns.forEach((openBtn) => {
            openBtn.addEventListener('click', () => {
                if (openBtn.classList.contains(OPEN_CLASS)) {
                    openBtn.classList.remove(OPEN_CLASS);
                    this._hideContent();
                } else {
                    openBtn.classList.add(OPEN_CLASS);
                    this._showContent();
                }
            });
        });

        window.addEventListener('resize', this._onWindowResize.bind(this));
    }

    _toggleFilterText() {
        const indexShowText = this.isShowAllIcons ? 0 : 1;

        this.filterToggleTexts.forEach((textElem, index) => {
            textElem.style.display = indexShowText === index ? 'block' : 'none';
        });
    }

    _handleChangeInput(event) {
        const isHidden = !event.target.checked;
        const type = event.target.value;

        this.iconElems.forEach((iconElem) => {
            if (type === iconElem.dataset.type) {
                this._toggleVisibleIcon(iconElem, isHidden);
                this._setIsShowAllIcons();
                this._toggleFilterText();
            }
        });
    }

    _toggleVisibleAllIcons(isHidden) {
        this.iconElems.forEach((iconElem) => {
            this._toggleVisibleIcon(iconElem, isHidden);
        });
    }

    _toggleVisibleIcon(item, isHidden) {
        item.classList.toggle(HIDDEN_CLASS, isHidden);
    }

    _toggleCheckedInputs(isChecked) {
        this.filterInputsIcons.forEach((input) => {
            if (input.checked !== isChecked) {
                input.checked = isChecked;
            }
        });
    }

    _setIsShowAllIcons() {
        this.isShowAllIcons = this.filterInputsIcons.every((input) => {
            return input.checked === true;
        });
    }

    _setHeightContentWrapper(height) {
        this.contentWrapper.style.height = Utils.isString(height) ? height : `${height}px`;
    }

    _showContent() {
        this.filter.classList.add(OPEN_FILTER_CLASS);
        this._updateHeightContent();
    }

    _hideContent() {
        this.filter.classList.remove(OPEN_FILTER_CLASS);
        this._setHeightContentWrapper(this.defaultHeight);
    }

    _updateHeightContent() {
        const isMobileTablet = Utils.isBreakpoint(0, 960);

        const height = isMobileTablet ? '100%' : this.content.offsetHeight;

        this._setHeightContentWrapper(height);
    }

    _onWindowResize() {
        if (this.filter.classList.contains(OPEN_FILTER_CLASS)) {
            this._updateHeightContent();
        }
    }
}
